/**
 * Registry of guardian-ui custom icons that extend @scality/core-ui's icon set.
 * Add entries here to make new PNG/SVG assets available via the <Icon> wrapper.
 *
 * Example:
 *   import myAgentImg from '../assets/my-agent.png';
 *   export const guardianIcons = { 'MyAgent': myAgentImg } as const;
 */

import opalImg from '../../public/agents/opal_alone.png';

export const guardianIcons = {
    'Opal': opalImg,
} as const;

export type GuardianIconName = keyof typeof guardianIcons;
